var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('img',{staticStyle:{"width":"167px"},attrs:{"src":"/static/images/null.png"}}),_c('div',{staticClass:"title"},[_vm._v("开发中")]),_c('div',{staticClass:"sub-title"},[_vm._v("敬请期待！")]),_c('div',{staticClass:"back",on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返 回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }